import {
  GoogleLoginProvider,
  SocialAuthService,
  SocialAuthServiceConfig,
} from '@abacritt/angularx-social-login';

export const GOOGLE_SIGN_IN_PROVIDER = [
  {
    provide: 'SocialAuthServiceConfig',
    useValue: {
      autoLogin: false,
      // TODO handle language from translations
      lang: 'en',
      providers: [
        {
          id: GoogleLoginProvider.PROVIDER_ID,
          // Google API OAuth 2.0 key
          provider: new GoogleLoginProvider(
            '203765496676-fahuvv1nou8p285gfmt9stmqonkpeu0f.apps.googleusercontent.com',
            {
              oneTapEnabled: false,
            },
          ),
        },
      ],
      onError: (err) => {
        console.error(err);
      },
    } as SocialAuthServiceConfig,
  },
  SocialAuthService,
];

// Invenit client
export const APPLE_CLIENT_ID = '';
